import doc                       from '@widesk-core/decorators/doc';
import AbstractMobileSliderModel from './AbstractMobileSliderModel';

@doc.urnResource('mobile_slider')
export default class MobileSliderModel extends AbstractMobileSliderModel {}
